import type { ShortcutContextValue } from '../type';
import ShortcutContext from './context';

const useShortcut = <
  NS extends Dictionary<string>,
  CMD extends Dictionary<string>,
>() => ShortcutContext.hook<ShortcutContextValue<NS, CMD>>();

export default useShortcut;
